import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { BiCheck, BiChevronLeft } from "react-icons/bi";
import { useNavigate } from "react-router";
import Card from "shared/components/Card";
import Header from "shared/components/Header";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { bindInputProps } from "utils/helpers/input";
import validation from "./validation";

const Create = ({ onSubmit, data, cancel }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.USER);
  const navigate = useNavigate();
  const CREATE = t("CREATE", { returnObjects: true });
  const FORM = t("FORM", { returnObjects: true });
  return (
    <Formik
      initialValues={{}}
      onSubmit={onSubmit}
      validationSchema={validation(
        t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
      )}
    >
      {({ isValid, handleSubmit, ...formProps }) => [
        <Header
          key={"header"}
          title={CREATE.HEADER.TITLE}
          subtitle={CREATE.HEADER.ACTION}
          actions={[
            {
              text: CREATE.HEADER.DISCARD,
              onClick: cancel,
              type: "primary--outlined",
              icon: <BiChevronLeft size={20} />,
            },
            {
              text: CREATE.HEADER.SAVE,
              onClick: handleSubmit,
              type: "primary",
              icon: <BiCheck size={20} />,
            },
          ]}
        />,
        <Card key="card" type={"simple"}>
          <div className="grid--2">
            <Input
              placeholder={FORM.FIRST_NAME}
              label={FORM.FIRST_NAME}
              {...bindInputProps({ name: "firstname", ...formProps })}
            />
            <Input
              placeholder={FORM.LAST_NAME}
              label={FORM.LAST_NAME}
              {...bindInputProps({ name: "lastname", ...formProps })}
            />
            <Input
              placeholder={FORM.PHONE}
              label={FORM.PHONE}
              {...bindInputProps({ name: "phone", ...formProps })}
            />
            <Input
              placeholder={FORM.EMAIL}
              label={FORM.EMAIL}
              {...bindInputProps({ name: "email", ...formProps })}
            />
            <Input
              placeholder={FORM.SELLER_CODE}
              label={FORM.SELLER_CODE}
              {...bindInputProps({ name: "meta.sellerCode", ...formProps })}
            />
          </div>
        </Card>,
      ]}
    </Formik>
  );
};

export default Create;
